import store from "@/store";
import { SunCalc, show_lunar_calendar } from "@/utils/Suncalc.js";
import {
  windLevel,
  windSpeed,
  moonList,
  moonRange,
  floodSeason,
} from "@/assets/publicData/weatherData";

export function getUrlInfoToStore(query) {
  query.token && store.commit("setToken", query.token);
  query.appNum && store.commit("setAppNum", query.appNum);
  query.reqId && store.commit("setReqId", query.reqId);
  query.source && store.commit("setSource", query.source);
  query.version && store.commit("setVersion", query.version);
  query.ip && store.commit("setIp", query.ip);
  return { ...query };
}

export function formatDegree(value) {
  value = Math.abs(value);
  const v1 = Math.floor(value); //度
  const v2 = Math.floor((value - v1) * 60); //分
  const v3 = Math.round(((value - v1) * 3600) % 60); //秒
  return v1 + "°" + v2 + "'" + v3 + '"';
}

/**
 * 返回风力等级
 * @param {number} data
 * @returns {string|number}
 */
export function dealWindLevelData(data) {
  data = parseInt(String(data));
  const result = windLevel.findIndex((item) => {
    return item.length > 1 ? data >= item[0] && data <= item[1] : data < item;
  });
  return result === -1 ? "-" : result;
}

/**
 * 返回风向名称
 * @param data
 * @returns {string}
 */
export function dealWindDirectionName(data) {
  data = Number(data);
  const result = windSpeed.find((item) => {
    return item.value[0] > item.value[1]
      ? data >= item.value[0] || item.value <= item.value[1]
      : data >= item.value[0] && data <= item.value[1];
  });
  return result ? result.name : "-";
}

// 处理港口潮汐tideInfos数据
export function dealPortTideInfoData(portTideData = []) {
  const result = new Map();
  if (portTideData instanceof Array) {
    portTideData.forEach((item) => {
      const { month, day, weekStr, hour, minutes } = dealPortTideTime(
        item.times,
      );
      const timeKey = `${month}/${day}`;
      const curTime = `${hour}:${minutes}`;
      if (result.has(timeKey)) {
        const curTimeKeyData = result.get(timeKey);
        curTimeKeyData?.["normalData"].push({ ...item, curTime });
        Number(item["is_peak"]) &&
          curTimeKeyData?.["peakData"].push({ ...item, curTime });
      } else {
        result.set(timeKey, {
          normalData: [{ ...item, curTime }],
          peakData: Number(item["is_peak"]) ? [{ ...item, curTime }] : [],
          datum: item.datum,
          timezone: item.timezone,
          timeKey,
          weekStr,
        });
      }
    });
  }
  return result;
}

// 处理港口潮汐sun数据
export function dealTideSunData(sunData = []) {
  const result = new Map();
  if (sunData instanceof Array) {
    for (const item of sunData) {
      const { year, month, day, weekStr } = dealPortTideTime(
        new Date(String(item.day)),
      );
      const timeKey = `${month}/${day}`;
      result.set(timeKey, {
        weekStr,
        timeKey,
        flood: formatLunar(show_lunar_calendar(year, month, day)),
        moonName: renderSunMoon(item.day),
        data: item.data,
      });
    }
  }
  return result;
}

export function getMooName(setState, riseState) {
  const index = moonRange.findIndex((ele) => {
    if (ele[2]) {
      return setState <= ele[0] && riseState >= ele[1];
    } else {
      return setState > ele[0] && riseState < ele[1];
    }
  });
  return index === -1 ? moonList[0] : moonList[index];
}

// 星出星落
export function renderSunMoon(day) {
  const riseState =
    SunCalc.getMoonIllumination(new Date(day + " " + "00:00:00")).phase - 0;
  const setState =
    SunCalc.getMoonIllumination(new Date(day + " " + "23:00:00")).phase - 0;
  return getMooName(setState, riseState);
}

export function formatLunar(val) {
  return floodSeason.includes(val) ? "死讯" : "活讯";
}

export const weekDate = [
  "星期天",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
];

// 处理港口潮汐数据时间
export function dealPortTideTime(timestamp) {
  const date = new Date(Number(timestamp));
  if (String(date) === "Invalid Date") {
    throw new Error("Invalid Date");
  } else {
    const year = date.getFullYear();
    const month = formatTimeVal(date.getMonth() + 1);
    const day = formatTimeVal(date.getDate());
    const week = date.getDay();
    const weekStr = weekDate[week];
    const hour = formatTimeVal(date.getHours());
    const minutes = formatTimeVal(date.getMinutes());
    return { year, month, day, week, weekStr, hour, minutes };
  }
}

export function formatTimeVal(time) {
  return Number(time) < 10 ? `0${time}` : time;
}

export function getBigFishAreaCoordinates(coordinates) {
  return [
    [
      [coordinates[0] - 0.245, coordinates[1] + 0.245],
      [coordinates[0] + 0.245, coordinates[1] + 0.245],
      [coordinates[0] + 0.245, coordinates[1] - 0.245],
      [coordinates[0] - 0.245, coordinates[1] - 0.245],
      [coordinates[0] - 0.245, coordinates[1] + 0.245],
    ],
  ];
}

export function getSmallFishAreaCoordinates(coordinates) {
  return [
    [
      [coordinates[0] - 0.5 / 6.1, coordinates[1] + 0.5 / 6.1],
      [coordinates[0] + 0.5 / 6.1, coordinates[1] + 0.5 / 6.1],
      [coordinates[0] + 0.5 / 6.1, coordinates[1] - 0.5 / 6.1],
      [coordinates[0] - 0.5 / 6.1, coordinates[1] - 0.5 / 6.1],
      [coordinates[0] - 0.5 / 6.1, coordinates[1] + 0.5 / 6.1],
    ],
  ];
}
import { set } from "lodash";

export function kvToJson(k, v) {
  const list = [];
  v.forEach((valueItem) => {
    let data = {};
    valueItem.forEach((item, index) => {
      if (Array.isArray(item)) {
        set(data, "list", {
          k: k[index],
          v: item,
        });
      } else {
        set(data, k[index], item);
      }
    });
    list.push(data);
  });
  return list;
}

export function formatTime(timestamp) {
  if (timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  } else {
    return "-";
  }
}

/**
 * 对象序列化
 */
export function serialize(data) {
  const list = [];
  Object.keys(data).forEach((ele) => {
    list.push(`${ele}=${data[ele]}`);
  });
  return list.join("&");
}
